export const GET_TRANSCO_HYPER_PROXI_INIT = 'GET_TRANSCO_HYPER_PROXI_INIT'
export const GET_TRANSCO_HYPER_PROXI_SUCCESS =
  'GET_TRANSCO_HYPER_PROXI_SUCCESS'
export const GET_TRANSCO_HYPER_PROXI_ERROR = 'GET_TRANSCO_HYPER_PROXI_ERROR'
export const GET_TRANSCO_HYPER_PROXI_PRODUCT_INIT =
  'GET_TRANSCO_HYPER_PROXI_PRODUCT_INIT'
export const GET_TRANSCO_HYPER_PROXI_PRODUCT_SUCCESS =
  'GET_TRANSCO_HYPER_PROXI_PRODUCT_SUCCESS'
export const GET_TRANSCO_HYPER_PROXI_PRODUCT_ERROR =
  'GET_TRANSCO_HYPER_PROXI_PRODUCT_ERROR'
export const GET_CREATED_TRANSCO_HYPER_PROXI_INIT =
  'GET_CREATED_TRANSCO_HYPER_PROXI_INIT'
export const GET_CREATED_TRANSCO_HYPER_PROXI_SUCCESS =
  'GET_CREATED_TRANSCO_HYPER_PROXI_SUCCESS'
export const GET_CREATED_TRANSCO_HYPER_PROXI_ERROR =
  'GET_CREATED_TRANSCO_HYPER_PROXI_ERROR'
export const GET_MODIFY_TRANSCO_HYPER_PROXI_INIT =
  'GET_MODIFY_TRANSCO_HYPER_PROXI_INIT'
export const GET_MODIFY_TRANSCO_HYPER_PROXI_SUCCESS =
  'GET_MODIFY_TRANSCO_HYPER_PROXI_SUCCESS'
export const GET_MODIFY_TRANSCO_HYPER_PROXI_ERROR =
  'GET_MODIFY_TRANSCO_HYPER_PROXI_ERROR'
export const GET_DELETE_TRANSCO_HYPER_PROXI_INIT =
  'GET_DELETE_TRANSCO_HYPER_PROXI_INIT'
export const GET_DELETE_TRANSCO_HYPER_PROXI_SUCCESS =
  'GET_DELETE_TRANSCO_HYPER_PROXI_SUCCESS'
export const GET_DELETE_TRANSCO_HYPER_PROXI_ERROR =
  'GET_DELETE_TRANSCO_HYPER_PROXI_ERROR'
export const UPDATE_PROVIDER_SEARCH = 'UPDATE_PROVIDER_SEARCH'
export const UPDATE_PRODUCT_SEARCH = 'UPDATE_PRODUCT_SEARCH'
